export default __webpack_public_path__ + "static/bentoSectionBg2-322116dfe0f157822e328644af4a8742.webp";